module.exports = __webpack_public_path__ + "img/icon-lugares.063f0ec7.svg";